import React from 'react'
import { useMediaQuery } from 'react-responsive'

function useResponsive() {
    const isBigScreen = useMediaQuery({ minWidth: '768px' });
    return {isBigScreen}
}

export default useResponsive